import { apiGet } from './index'


export function getTrade() {
    let url = "/api/TradeCode/list";
    return apiGet(url);
}
